<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="d-flex flex-column h-100" *ngIf="!isloader && !isError">
    <div class="vehicle-profile-header">{{widgetData?.title}}</div>
    <div class="d-flex vehicle-score-sizing">
        <div>

            <div class="d-flex justify-content-center flex-column">
                <div class="d-flex align-items-center">
                    <div class="starlogo"><img src="../../../../assets/images/rewardpoint.svg" alt="rewardimage"
                            class="img-fluid  wh40"></div>
                    <div class="vehicle-score-value d-flex">85</div>
                </div>
                <div class="vehicle-rating">Very good</div>
            </div>

        </div>
        <div class="vehicle-activity">
            <div class="d-flex">
                <div>Idle</div>
                <div>{{scoreData?.entityUtilization?.idle}}</div>
            </div>
            <div class="d-flex">
                <div>Safe Driving</div>
                <div>{{scoreData?.entityBehaviour?.safeDriving}}</div>
            </div>
        </div>
    </div>
</div>
<p *ngIf="isloader || isError">No Data Available</p>